module.exports = __webpack_public_path__ + "img/solution_overview.31ae5b63.png";